export const PIPE_MARKET_PARTNER_ID = 'ba6badba-716a-49ee-a6db-199858156735';

export function resolveWo2894Route(key) {
  return !key || key === 'home' ? 'dashboard' : key;
}

export function isWo2894DefaultEntry(hash) {
  const path = String(hash || '').replace(/^#\/?/, '').split('?')[0];
  return path === '' || path === 'home';
}

export function wo2894EntryPartner({ hash, partners = [] }) {
  if (!isWo2894DefaultEntry(hash)) return null;
  return partners.find((partner) => partner.id === PIPE_MARKET_PARTNER_ID && partner.active !== false) || null;
}
